/* eslint-disable react/prop-types */
import { Marker } from '@react-google-maps/api';

export const Marcador = ({ onClick, data }) => {
  return (
    <Marker
      onClick={(e) => onClick(e, data)}
      position={data.cordenadas}
      title={`${'hallazgos:'}${data.idHallazgo}${'\n'}${'calle:'}${data.calle}${'\n'}${'colonia:'}${
        data.colonia
      }`}
      label={data.referencias}
    />
  );
};
